(function() {
  function shuffleArray(array) {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

 function formatMoney(cents) {
    return '$' + parseFloat(cents).toFixed(2);
  }

  function showSkeletons(grid) {
    const count = parseInt(grid.dataset.productsCount) || 20;
    grid.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const card = document.createElement('div');
      card.className = 'random-product-card skeleton-card';
      card.innerHTML = `
        <div class="skeleton-img"></div>
        <div class="skeleton-info">
          <div class="skeleton-line long"></div>
          <div class="skeleton-line medium"></div>
          <div class="skeleton-line short"></div>
          <div class="skeleton-btn"></div>
        </div>
      `;
      grid.appendChild(card);
    }
  }

  function renderProducts(grid, products) {
    grid.innerHTML = '';
    if (!products.length) {
      grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:40px;color:#999;">No products found.</div>';
      return;
    }
    products.forEach(function(product) {
      const image = product.images && product.images.length > 0
        ? product.images[0].src
        : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';

      const price = formatMoney(product.variants[0].price);
      const comparePrice = product.variants[0].compare_at_price && product.variants[0].compare_at_price > product.variants[0].price
        ? formatMoney(product.variants[0].compare_at_price)
        : null;

      const card = document.createElement('a');
      card.className = 'random-product-card';
      card.href = '/products/' + product.handle;
      card.innerHTML = `
        <div class="random-product-img-wrap">
          <img src="${image}" alt="${product.title}" loading="lazy">
        </div>
        <div class="random-product-info">
          <div class="random-product-title">${product.title}</div>
          <div>
            <span class="random-product-price">${price}</span>
            ${comparePrice ? `<span class="random-product-price-compare">${comparePrice}</span>` : ''}
          </div>
          <button class="random-product-btn">View Product</button>
        </div>
      `;
      grid.appendChild(card);
    });
  }

  function distributeProducts(allProducts, grids) {
    const shuffled = shuffleArray(allProducts);
    const usedIds = new Set();
    let currentIndex = 0;

    grids.forEach(function(grid) {
      const count = parseInt(grid.dataset.productsCount) || 20;
      const sectionProducts = [];

      while (sectionProducts.length < count && currentIndex < shuffled.length) {
        const product = shuffled[currentIndex];
        currentIndex++;
        if (usedIds.has(product.id)) continue;
        usedIds.add(product.id);
        sectionProducts.push(product);
      }

      renderProducts(grid, sectionProducts);
    });
  }

  async function initRandomProducts() {
    const grids = document.querySelectorAll('.random-products-grid');
    if (!grids.length) return;

    // Show skeletons immediately
    grids.forEach(function(grid) {
      showSkeletons(grid);
    });

    let allProducts = [];
    let page = 1;
    let hasMore = true;
    let rendered = false;

    while (hasMore) {
      try {
        const response = await fetch(`/products.json?limit=250&page=${page}`);
        const data = await response.json();

        if (data.products && data.products.length > 0) {
          data.products.forEach(function(product) {
            if (!allProducts.find(p => p.id === product.id)) {
              allProducts.push(product);
            }
          });

          // Render after first batch for speed — but only if not rendered yet
          if (!rendered && allProducts.length >= 32) {
            distributeProducts(allProducts, grids);
            rendered = true;
          }

          page++;
          if (data.products.length < 250) {
            hasMore = false;
          }
        } else {
          hasMore = false;
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        hasMore = false;
      }
    }

    // Only re-render if we never rendered yet
    if (!rendered) {
      distributeProducts(allProducts, grids);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRandomProducts);
  } else {
    initRandomProducts();
  }
})();